import actionTypes from 'SRC/modules/redux/actionTypes'

export const setNotifications = (notifications) => ({
  type: actionTypes.SET_NOTIFICATIONS,
  payload: notifications
})
